<template>
  <div class="pa-6">
    <v-snackbar
      :timeout="3000"
      v-model="showDuplicateLinkCopied"
      color="#00AEEF"
      top
      centered
    >
      <p class="body1 mr-3">
        {{ $t("project_list.modal.share.duplication.snackbar.copy") }}
      </p>
      <v-icon class="snackbar-icon" @click="showDuplicateLinkCopied = false">
        $iconClose
      </v-icon>
    </v-snackbar>
    <h2>
      {{ $t("project_list.modal.share.duplication.title") }}
    </h2>
    <p
      class="body2 mt-6"
      v-html="$t('project_list.modal.share.duplication.explanation')"
    ></p>
    <v-row class="mt-7">
      <v-col>
        <p class="body2">
          {{ $t("project_list.modal.share.duplication.instruction") }}
        </p>
      </v-col>
      <v-col>
        <niko-button
          :text="$t('project_list.modal.share.duplication.button')"
          @onClick="generateSnapshot()"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NikoButton from "@/components/UI/NikoButton";
import { eventBus } from "@/components/EventBus";

export default {
  name: "share-duplication",
  components: { NikoButton },
  data: () => ({
    showDuplicateLinkCopied: false,
  }),
  methods: {
    ...mapActions("projectsStore", ["generateSnapshot"]),
  },
  created() {
    eventBus.$on(
      "duplicateLinkCopied",
      () => (this.showDuplicateLinkCopied = true)
    );
  },
  destroyed() {
    eventBus.$off("duplicateLinkCopied");
  },
};
</script>
